<template>
  <div class="pa-4">
    <h2 class="text-h5 font-weight-bold mb-6">Profil Angajat</h2>

    <v-progress-linear v-if="loading" indeterminate color="red-darken-1" class="mb-4" />

    <v-row v-if="profil">
      <!-- Date personale (read-only) -->
      <v-col cols="12" md="6">
        <v-card elevation="2" rounded="xl" class="mb-4">
          <v-card-title class="pa-4 pb-2">
            <v-icon class="mr-2" color="red-darken-1">mdi-account-details</v-icon>
            Date angajat
          </v-card-title>
          <v-divider />
          <v-card-text class="pa-4">
            <div class="info-row" v-for="camp in campuriReadOnly" :key="camp.key">
              <span class="info-label">{{ camp.label }}</span>
              <span class="info-value">{{ profil[camp.key] ?? '—' }}</span>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Date de contact editabile -->
      <v-col cols="12" md="6">
        <v-card elevation="2" rounded="xl">
          <v-card-title class="pa-4 pb-2">
            <v-icon class="mr-2" color="blue-darken-1">mdi-pencil</v-icon>
            Date de contact
          </v-card-title>
          <v-divider />
          <v-card-text class="pa-4">
            <v-form v-model="editValid" ref="editForm">
              <v-text-field
                v-model="editForm.Email"
                label="Email"
                prepend-inner-icon="mdi-email"
                variant="outlined"
                density="comfortable"
                class="mb-3"
                :rules="[emailRule]"
                type="email"
              />
              <v-text-field
                v-model="editForm.Telefon"
                label="Telefon"
                prepend-inner-icon="mdi-phone"
                variant="outlined"
                density="comfortable"
              />
            </v-form>
            <v-alert v-if="saveMsg" :type="saveMsgType" variant="tonal" class="mt-2" closable @click:close="saveMsg = ''">
              {{ saveMsg }}
            </v-alert>
          </v-card-text>
          <v-card-actions class="pa-4">
            <v-spacer />
            <v-btn color="red-darken-1" :loading="saveLoading" :disabled="!editValid" @click="salveaza">
              <v-icon class="mr-1">mdi-content-save</v-icon> Salvează
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import PORTAL_Profil from '@/services/Portal/PORTAL_Profil'

export default defineComponent({
  name: 'ProfilAngajat',
  data() {
    return {
      loading: false, saveLoading: false,
      editValid: false,
      profil: null as any,
      editForm: { Email: '', Telefon: '' },
      saveMsg: '', saveMsgType: 'success' as 'success' | 'error',
      campuriReadOnly: [
        { key: 'LastName', label: 'Nume' },
        { key: 'FirstName', label: 'Prenume' },
        { key: 'InternalCode', label: 'Marcă' },
        { key: 'PositionId', label: 'Funcție' },
        { key: 'StructId', label: 'Departament' },
        { key: 'ContractStartDate', label: 'Data angajare' },
      ]
    }
  },
  async mounted() {
    this.loading = true;
    try {
      const resp = await PORTAL_Profil.get();
      this.profil = resp.data;
      this.editForm.Email = this.profil?.Email ?? '';
      this.editForm.Telefon = this.profil?.Telefon ?? '';
    } finally {
      this.loading = false;
    }
  },
  methods: {
    emailRule(v: string) { return !v || /.+@.+\..+/.test(v) || 'Email invalid'; },
    async salveaza() {
      this.saveLoading = true;
      try {
        await PORTAL_Profil.update(this.editForm);
        this.saveMsg = 'Date salvate cu succes!';
        this.saveMsgType = 'success';
      } catch {
        this.saveMsg = 'Eroare la salvare.';
        this.saveMsgType = 'error';
      } finally {
        this.saveLoading = false;
      }
    }
  }
})
</script>

<style scoped>
.info-row { display: flex; padding: 0.5rem 0; border-bottom: 1px solid #f0f0f0; }
.info-row:last-child { border-bottom: none; }
.info-label { font-size: 0.8rem; color: #718096; width: 140px; flex-shrink: 0; font-weight: 500; }
.info-value { font-size: 0.9rem; color: #1a202c; flex: 1; }
</style>
